import React from 'react';
import {useSelector} from 'react-redux';

import * as S from './RoomSelection.styles';

import {roomsFilterDataSelector} from '../../selectors';

import {RfElementType} from '../../redux/types';

const Filter = ({
  setFilters,
  currentFilters = [],
}: {
  setFilters: Function;
  currentFilters: Array<RfElementType>;
}) => {
  const roomsFilterData = useSelector(roomsFilterDataSelector);

  if (!roomsFilterData.length) {
    return null;
  }

  return (
    <S.RoomAmenitesSortWrap>
      <S.RoomAmenitiesSortList>
        {roomsFilterData.map((currentIterationFilter, index: string) => {
          let filterCount = 0;
          currentIterationFilter.fd.map(fdEach => {
            filterCount += fdEach.grpil.length;
          });

          return (
            <li
              key={`${currentIterationFilter.name}-${index}`}
              className={currentFilters.some(filter => filter.fc === currentIterationFilter.fc) ? 'active' : ''}
              onClick={e =>
                setFilters(prevFilters => {
                  const alreadyPresent = prevFilters.some(
                    filter => filter.name === currentIterationFilter.name,
                  );

                  return alreadyPresent
                    ? prevFilters.filter(
                        filter => filter.name !== currentIterationFilter.name,
                      )
                    : [...prevFilters, currentIterationFilter];
                })
              }
            >
              {currentIterationFilter.name} ({!!filterCount ? filterCount : ''})
            </li>
          );
        })}
      </S.RoomAmenitiesSortList>
    </S.RoomAmenitesSortWrap>
  );
};

export default Filter;
